import { withStyles } from "@mui/styles";

import SingleLineTextInput from "../../components/singleLineTextInput/SingleLineTextInput";
import ErrorMessage from "../../components/errorMessage/ErrorMessage";

const isInvalidPassword = (name) => !name;

const styles = (theme) => ({
  section: {
    width: "100%",
    backgroundColor: "#fff",
  },
});

function EditEmailForm({
  classes,
  payload,
  storePayload,
  errorMessage,
  submitAttempted,
}) {
  return (
    <div className={classes.section}>
      <SingleLineTextInput
        label="EMAIL ADDRESS"
        value={payload.emailAddress}
        onChange={(value) => storePayload({ ...payload, emailAddress: value })}
        showInvalidInput={
          submitAttempted && isInvalidPassword(payload.firstName)
        }
        required={true}
      />

      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
}

export default withStyles(styles)(EditEmailForm);
